import React from "react";
import {mergeClasses} from "@material-ui/styles";

import RadioFormElement from "../RadioFormElement";

import useStyles from "./styles";

const RadioCard = (props) => {
  const {custom_classes, newDesign, ...otherProps} = props;

  const classes = useStyles();

  return (
    <RadioFormElement
      {...otherProps}
      custom_classes={newDesign ?
        mergeClasses({
          baseClasses: classes,
          newClasses: custom_classes,
          Component: RadioCard
        }) : custom_classes
      }
    />
  )
};

export default RadioCard;